<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="m-0 p-3 background-primary-blue height-70px shadow z-max d-flex justify-content-between align-items-center">
        <app-back-button/>
        <div class="text-center color-white p-4 fs-lg">NFC tags</div>
        <app-close-button/>
    </div>
    @let optionalDevice = device();
    @let optionalAnimal = animal();
    <div class="d-flex flex-column p-3 gap-5 overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div class="d-flex flex-column gap-3">
            @if (hasNativeScanningDialog()) {
                <app-generic-button
                    (click)="startScan()"
                    description="Detect and read NFC tag"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-info'"
                    buttonText="Detect and read NFC tag"
                    [disabled]="loading()"/>
            } @else {
                <app-generic-button
                    (click)="startScan()"
                    description="Detect and read NFC tag"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-info'"
                    buttonText="Detect and read NFC tag"
                    [loading]="scanning()"
                    [disabled]="loading() || scanning()"/>
                <app-generic-button
                    (click)="stopScan()"
                    description="Stop scanning for NFC tags"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-info'"
                    buttonText="Stop scanning for NFC tags"
                    [disabled]="!scanning()"/>
            }
            @if (optionalAnimal !== undefined) {
                <div class="card p-3">
                    Received {{ sampleValues().length }} locations for '{{ optionalAnimal.visualTag }}''.
                </div>
                <app-generic-button
                    (click)="processLocations()"
                    description="Process locations obtained from NFC tag"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-info'"
                    buttonText="Process locations"
                    [disabled]="!canProcessLocations()"/>
            } @else if (optionalDevice !== undefined && optionalAnimal === undefined) {
                <div class="card p-3">
                    Tag '{{optionalDevice.id | slice:-5}}' is not associated with any animal yet.
                </div>
                @if (!showAnimalCreationForm()) {
                    <app-generic-button
                        (click)="toggleShowAnimalCreationForm()"
                        description="Show form to create animal for NFC tag"
                        [alwaysShowText]="true"
                        [buttonClass]="'btn-info'"
                        buttonText="Create animal"
                        [primaryIcon]="'fa-solid fa-plus'"/>
                  <app-generic-button
                    (click)="share()"
                    description="Create animal for NFC tag"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-info'"
                    buttonText="Share raw data"
                    [primaryIcon]="'fa-solid fa-plus'"/>
                } @else {
                    <div>
                        <div class="row">
                            <div class="col fw-bold">Name</div>
                        </div>
                        <div class="row">
                            <div class="input-group">
                                <input (input)="setName($event)"
                                        [ngClass]="{'is-invalid': name() === undefined}"
                                        [value]="name() ?? ''"
                                        class="form-control m-auto"
                                        placeholder="Animal name"
                                        required
                                        style="padding-right: 30px;"
                                        type="text">
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="row">
                            <div class="col fw-bold">Animal type</div>
                            <div class="col fw-bold">Year born</div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button
                                    aria-controls="animalTypeCollapse"
                                    aria-expanded="false"
                                    class="btn btn-info dropdown-toggle w-100"
                                    data-bs-target="#animalTypeCollapse"
                                    data-bs-toggle="collapse"
                                    type="button">
                                    {{ animalType() || "Select" | toCapitalizedText }}
                                </button>
                                <div class="collapse"
                                        id="animalTypeCollapse">
                                    @for (animalType of animalTypes(); track animalType) {
                                        <div (click)="setAnimalType(animalType)"
                                                aria-controls="animalTypeCollapse" class="btn card m-1"
                                                data-bs-target="#animalTypeCollapse"
                                                data-bs-toggle="collapse">{{ animalType | toCapitalizedText }}
                                        </div>
                                    }
                                </div>
                            </div>
                            <div class="col dropdown">
                                <button
                                    aria-controls="yobCollapse"
                                    aria-expanded="false"
                                    class="btn btn-info dropdown-toggle w-100"
                                    data-bs-target="#yobCollapse"
                                    data-bs-toggle="collapse"
                                    id="yobDropdownMenuButton"
                                    type="button">
                                    {{ year() || "Select" }}
                                </button>
                                <div class="collapse"
                                        id="yobCollapse">
                                    @for (year of years(); track year) {
                                        <div (click)="setYear(year)"
                                                aria-controls="yobCollapse"
                                                class="btn card m-1"
                                                data-bs-target="#yobCollapse"
                                                data-bs-toggle="collapse">{{ year }}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <app-generic-button
                        (click)="createAnimal()"
                        description="Create animal for NFC tag"
                        [alwaysShowText]="true"
                        [buttonClass]="'btn-info'"
                        buttonText="Create animal"
                        [primaryIcon]="'fa-solid fa-plus'"
                        [disabled]="!canCreateAnimal()"/>
                }
            }
        </div>

    </div>
</div>
